module.exports = __webpack_public_path__ + "img/productions_35.43a671a5.png";